module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2026_fr-50cebed9c15072c82f36fda4b69fa455.jpg";